<template>
    <base-nav class="navbar-top navbar-dark"
              id="navbar-main"
              :show-toggle-button="false"
              expand>
        <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex mx-md-auto">
            <div class="form-group mb-0">
               <!--- <base-input placeholder="Search"
                            class="input-group-alternative"
                            alternative=""
                            addon-right-icon="fas fa-search">
                </base-input>--->
            </div>
        </form>


        <NotificationBell v-if="windowWidth >= 992" class="mr-4"/>
        <ul class="navbar-nav align-items-center d-none d-md-flex">
            <li class="nav-item dropdown">
                <base-dropdown class="nav-link pr-0" >
                    <div class="media align-items-center" slot="title">
                <SocialguardAvatar/>
                        <div class="media-body ml-2 d-none d-md-block">
                            <span class="mb-0 text-sm  font-weight-bold">{{ $store.getters['authentication/name'] }} <br> (UID: {{ $store.getters['authentication/uid'] }})</span>
                        </div>
                    </div>
                    <UserMenu/>
                </base-dropdown>
            </li>
        </ul>
    </base-nav>
</template>
<script>
    import SocialguardAvatar from "@/components/SidebarPlugin/SocialguardAvatar";
    import UserMenu from "@/layout/UserMenu";
    import NotificationBell from "@/layout/NotificationBell";

    export default {
      components: {NotificationBell, UserMenu, SocialguardAvatar},
    data() {
      return {
          activeNotifications: false,
          showMenu: false,
          searchQuery: '',
          windowWidth: window.innerWidth
      };
    },
    methods: {
      toggleSidebar() {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
      },
      hideSidebar() {
        this.$sidebar.displaySidebar(false);
      },
      toggleMenu() {
        this.showMenu = !this.showMenu;
      },

    }
  };
</script>

